<template>
  <!-- Failed user message -->
  <div class="message-container user-message message-not-sent">
    <div class="message-content user-content">
      <!-- Sender info and error icon -->
      <div class="message-header user-header">
        <span class="sender-name">{{ senderName }}</span>
        <!-- Error outline icon -->
        <div class="error-icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="#D10000"/>
          </svg>
        </div>
      </div>

      <!-- Failed message bubble with triangle arrow -->
      <div class="message-bubble">
        <div class="bubble-content user-bubble">
          <!-- Message content -->
          <div class="message-text">{{ messageText }}</div>

          <!-- Close/X icon -->
          <div class="close-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#D10000"/>
            </svg>
          </div>
        </div>

        <!-- Triangle arrow -->
        <div class="arrow-position">
          <img src="@/assets/MyPatient/message_notsent_triangle.svg" alt="Arrow" class="arrow-icon"/>
        </div>
      </div>

      <!-- Error message below bubble -->
      <div class="error-message">Failed to send message.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageNotSent',
  props: {
    messageText: {
      type: String,
      required: true
    },
    senderName: {
      type: String,
      default: 'You'
    },
    timestamp: {
      type: [String, Date],
      default: () => new Date()
    }
  }
};
</script>

<style scoped>
.message-container {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  max-width: 100%;
}

/* User messages (right side) */
.user-message {
  flex-direction: row-reverse;
}

.message-content {
  flex: 1;
  min-width: 0;
  max-width: 100%;
}

.user-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 118px;
  padding-bottom: 4px;
  gap: 4px;
}

/* Header with sender name and error icon */
.message-header {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
}

.user-header {
  flex-direction: row-reverse;
}

.sender-name {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #333333;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* Error outline icon */
.error-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}

/* Message bubble - matches message.vue structure */
.message-bubble {
  position: relative;
  max-width: 100%;
  word-wrap: break-word;
}

.bubble-content {
  padding: 10px 24px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  position: relative;
  color: #000000;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
}

/* User bubble - same as message.vue but with error background */
.user-bubble {
  background-color: #FAEAEA;
  border-radius: 20px 20px 20px 20px;
  margin-right: 14px;
}

.message-text {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333333;
  word-wrap: break-word;
  white-space: pre-wrap;
  flex-shrink: 0;
}

/* Close/X icon */
.close-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}

/* Triangle arrow - positioned like in message.vue */
.arrow-position {
  position: absolute;
  top: 8px;
  right: 2px;
}

.arrow-icon {
  width: 18px;
  height: 18px;
}

/* Error message below bubble */
.error-message {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
  color: #999999;
  letter-spacing: 0.5px;
  text-align: right;
  padding: 0 18px;
  white-space: nowrap;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .message-content {
    max-width: calc(100vw - 80px);
  }

  .bubble-content {
    padding: 10px 14px;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
